export default __webpack_public_path__ + "static/media/kitteh.956e8935.jpg";